<template>
  <div style="padding: 190px 80px 0 80px">
    <el-form ref="form1" label-width="140px" size="mini" class="dolu">
      <el-row>
        <el-col :span="24" class="card-01">
          <el-row :gutter="20" style="margin-bottom: 25px;">
            <el-col :span="24" class="text-01">Vyšetření
            </el-col>
            <el-col :span="24" class="text-02">Osobní data pacienta
            </el-col>          
          </el-row>         

          <el-row>
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Jméno a příjmení">
                  <el-col :span="6">
                    <el-input v-model="ex_pat_name" placeholder="Jméno"></el-input>
                  </el-col>
                  <el-col :span="10">
                    <el-input v-model="ex_pat_surname" placeholder="Příjmení"></el-input>
                  </el-col>
                  <el-col :span="8">

                  </el-col>                
                </el-form-item>
                <el-form-item label="Číslo pojištěnce">
                  <el-col :span="8">
                    <el-input v-model="ex_pat_insu_num" prefix-icon="el-icon-user" @change="change_lr_req_insu_num" placeholder="Číslo pojištěnce"></el-input> 
                  </el-col>
                  <el-col :span="8">
                    <el-date-picker type="date" placeholder="Datum narození" v-model="ex_pat_birth_date" style="width: 100%;"></el-date-picker>
                  </el-col> 
                  <el-col :span="8">
                    <el-select v-model="ex_pat_id_inco" placeholder="Zdravotní pojišťovna" @change="change_inco"> 
                      <el-option
                        v-for="one of l_insurance_companies"
                        :key="one.id_inco"
                        :label="one.inco_name"
                        :value="one.id_inco"
                        >
                      </el-option>
                    </el-select>
                  </el-col>                
                </el-form-item>                           

                <el-form-item label="Pohlaví">
                  <el-col :span="8">       
                    <el-radio v-model="ex_pat_gender" label="1">Žena</el-radio>
                    <el-radio v-model="ex_pat_gender" label="2">Muž</el-radio>
                  </el-col>   
                  <el-col :span="16">       
                  </el-col>                              
                </el-form-item> 

                <el-form-item label="Adresa pacienta">
                  <el-col :span="9">
                    <el-input v-model="ex_pat_street" prefix-icon="el-icon-place" placeholder="Ulice"></el-input>
                  </el-col>
                  <el-col :span="7">
                    <el-input v-model="ex_pat_city" prefix-icon="el-icon-office-building" placeholder="Město"></el-input>
                  </el-col>
                  <el-col :span="4">
                    <el-input v-model="ex_pat_zip_code" prefix-icon="el-icon-office-building" placeholder="PSČ" minlength="5"></el-input>
                  </el-col>   
                  <el-col :span="4">
                    <el-input v-model="ex_pat_country" prefix-icon="el-icon-map-location" placeholder="Stát" minlength="5"></el-input>
                  </el-col>                              
                </el-form-item>

                <el-form-item label="Kontaktní údaje">
                  <el-col :span="10">
                    <el-input v-model="ex_pat_phone" prefix-icon="el-icon-phone-outline" placeholder="Telefon"></el-input>
                  </el-col>
                  <el-col :span="14">
                    <el-input v-model="ex_pat_email" prefix-icon="el-icon-message" placeholder="E-mail"></el-input>
                  </el-col>
                </el-form-item>

              
                <el-col :span="24">
                  <div>
                    <el-divider></el-divider>
                  </div>
                </el-col>  

              </el-row>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24" class="text-02">První možnost zobrazení (cascader)
            </el-col>          
          </el-row>          

          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="První příznak (A)">
                  <el-col>
                    <el-cascader
                      v-model="ex_prvni_priznak_pos"
                      :options="prvni_priznak_pos"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="První příznak (N)">
                  <el-col>
                    <el-cascader

                      :options="prvni_priznak_pos"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>          
          </el-row>
          <el-row class="">
            <el-col :xs="11" :sm="11" :md="5" :lg="5" :xl="5">
              <el-row class="box-card-small-01">
                <el-form-item label="Délka anamnézy">
                  <el-col>
                    <el-input v-model="ex_delka_anamnezy" placeholder="Počet dnů"></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>        
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Neurologický deficit (A)">
                  <el-col>
                    <el-cascader
                      :options="neurol_deficit"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="">
                  <el-col>
                    <el-radio v-model="ex_neurol_deficit_a_n" label="1">Ano</el-radio>
                    <el-radio v-model="ex_neurol_deficit_a_n" label="2">NE</el-radio>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>          
          </el-row>
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="NTH (A)">
                  <el-col>
                    <el-cascader
                      :options="d_nth"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Lanského skóre">
                  <el-col>
                    <el-select v-model="ex_lansky_skore" placeholder="Vyber hodnotu">
                      <el-option
                        v-for="item in lansky_skore"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>  
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="ECOG skóre">
                  <el-col>
                    <el-select v-model="ex_ecog_skore" placeholder="Vyber hodnotu">
                      <el-option
                        v-for="item in ecog_skore"
                        :key="item"
                        :label="item"
                        :value="item">
                      </el-option>
                    </el-select>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row> 
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Škola">
                  <el-col>
                    <el-cascader
                      :options="d_skola"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber školu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>  
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Primární nádor">
                  <el-col>
                    <el-cascader
                      :options="d_primarni_nador"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row> 
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Další nádor">
                  <el-col>
                    <el-cascader
                      :options="d_dalsi_nador"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Primární observace">
                  <el-col>
                    <el-cascader
                      :options="d_primarne_observace"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row> 
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Observace nádoru">
                  <el-col>
                    <el-cascader
                      :options="d_observace_nadoru"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>  
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Ukončena pro">
                  <el-col>
                    <el-cascader
                      :options="d_ukoncena_pro"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Datum ukončení">
                  <el-col :span="8">
                    <el-date-picker type="date" v-model="ex_d_datum_ukonceni" style="width: 100%;"></el-date-picker>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>                                                                                              
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Operace">
                  <el-col>
                    <el-cascader
                      :options="d_operace"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Pooperační stav">
                  <el-col>
                    <el-cascader
                      :options="d_pooperacni_stav"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>        
          <el-row class="">
            <el-col :xs="22" :sm="22" :md="11" :lg="11" :xl="11">
              <el-row class="box-card-small-01">
                <el-form-item label="Ambulantní kontrola">
                  <el-col>
                    <el-cascader
                      :options="d_ambulantni_kontrola"
                      :props="props"
                      clearable
                      :multiple="true"
                      size="mini"
                      placeholder="Vyber variantu"
                      show-all-levels
                      >
                    </el-cascader>
                  </el-col>
                </el-form-item>
              </el-row>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </el-form>

    <el-form ref="form2" size="mini" style="margin-top: 10px">
      <el-row :gutter="20">
        <el-col :span="24">
          <div class="card-01">
            <el-row>
            <el-col :span="24" class="text-02">Další nástin zobrazení (různé varianty - checkbox, select, button, ...)</el-col>
            <h3>První příznak</h3>
            </el-row>
            <el-row>
              <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
                <el-row :gutter="20">
                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="card-02">
                      <h5 class="text-03">První příznak ANO</h5>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox label="Asympt"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <div style="margin-top: 0px">
                                  </div>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox v-model="chb_fokal_deficit" label="Fokal deficit"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <el-select :disabled="!(chb_fokal_deficit)" v-model="chb_fokal_deficit_data" multiple placeholder="Vyber variantu">
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-col>
                              </el-form-item>
                          </el-col>                        
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 3px 5px">
                                <el-col>
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="Jiný"
                                    v-model="textarea">
                                  </el-input>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>  

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5" >
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <el-checkbox v-model="chb_epilepsie" label="Epilepsie"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="bor" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <div style="margin-top: 0px; padding: 0 5px 0 5px">
                                    <el-checkbox-group :disabled="!(chb_epilepsie)" v-model="chb_epilepsie_data">
                                      <el-checkbox label="Grandmal"></el-checkbox>
                                      <el-checkbox label="Jackson"></el-checkbox>
                                      <el-checkbox label="Jiná"></el-checkbox>
                                    </el-checkbox-group>
                                  </div>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 3px 5px">
                                <el-col>
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="Jiná"
                                    v-model="textarea">
                                  </el-input>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox v-model="chb_nth" label="NTH"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <div style="margin-top: 0px; padding: 0 5px 0 5px">
                                    <el-checkbox-group :disabled="!(chb_nth)" v-model="chb_nth_data" size="small">
                                      <el-checkbox-button v-for="city in NTH" :label="city" :key="city">{{city}}</el-checkbox-button>
                                    </el-checkbox-group>
                                  </div>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox-group v-model="checkList">
                                  <el-checkbox label="Ataxie"></el-checkbox><br>
                                  <el-checkbox label="Jiný"></el-checkbox>
                                  </el-checkbox-group>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>
  
                    </div>                                                               
                  </el-col>

                  <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                    <div class="card-03">
                      <h5 class="text-03">První příznak NE</h5>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox label="Asympt"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <div style="margin-top: 0px">
                                  </div>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>

                        <el-row :gutter="5">
                          <el-col :xs="24" :sm="24" :md="5" :lg="5" :xl="5">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col >
                                  <el-checkbox v-model="chb_fokal_deficit_n" label="Fokal deficit"></el-checkbox>
                                </el-col>
                              </el-form-item>
                          </el-col>
                          <el-col :xs="24" :sm="24" :md="11" :lg="11" :xl="11">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 0 5px">
                                <el-col>
                                  <el-select :disabled="!(chb_fokal_deficit_n)" v-model="chb_fokal_deficit_n_data" multiple placeholder="Vyber variantu">
                                    <el-option
                                      v-for="item in options"
                                      :key="item.value"
                                      :label="item.label"
                                      :value="item.value">
                                    </el-option>
                                  </el-select>
                                </el-col>
                              </el-form-item>
                          </el-col>                        
                          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
                              <el-form-item class="" style="margin-bottom: 0px; padding: 0 5px 3px 5px">
                                <el-col>
                                  <el-input
                                    type="textarea"
                                    :rows="3"
                                    placeholder="Jiný"
                                    v-model="textarea">
                                  </el-input>
                                </el-col>
                              </el-form-item>
                          </el-col>              
                        </el-row>  
  
                    </div>                                                               
                  </el-col>
                </el-row> 
                </el-col>
            </el-row> 

          </div>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  import { mapState, mapGetters, mapMutations, mapActions } from 'vuex';
  const nthOptions = ['Cefalea', 'Porucha vědomí'];

  export default {
    components: {

    },

    data () {
      return {
        props: { 
          multiple: true,
        },

        checkList: ['selected and disabled','Asympt'],
        textarea: '',

 
      }
    },


    computed: {
      ...mapState({
        token: state => state.token,
        patient: state => state.patient,
        exam_01: state => state.exam_01,
        exam: state => state.exam,

        prvni_priznak_pos: state => state.prvni_priznak_pos,
        delka_anamnezy: state => state.delka_anamnezy,         
        neurol_deficit: state => state.neurol_deficit,  
        neurol_deficit_a_n: state => state.neurol_deficit_a_n,          
        d_nth: state => state.d_nth,    
        d_skola: state => state.d_skola,   
        d_primarni_nador: state => state.d_primarni_nador, 
        d_dalsi_nador: state => state.d_dalsi_nador,   
        d_primarne_observace: state => state.d_primarne_observace,    
        d_observace_nadoru: state => state.d_observace_nadoru,  
        d_ukoncena_pro: state => state.d_ukoncena_pro, 
        d_datum_ukonceni: state => state.d_datum_ukonceni,         
        lansky_skore: state => state.lansky_skore, 
        ecog_skore: state => state.ecog_skore,  
        d_skola: state => state.d_skola,  
        d_primarni_nador: state => state.d_primarni_nador,   
        d_dalsi_nador: state => state.d_dalsi_nador, 
        d_primarne_observace: state => state.d_primarne_observace, 
        d_observace_nadoru: state => state.d_observace_nadoru, 
        d_ukoncena_pro: state => state.d_ukoncena_pro,
        d_datum_ukonceni: state => state.d_datum_ukonceni,   
        d_operace: state => state.d_operace, 
        d_pooperacni_stav: state => state.d_pooperacni_stav,         
        d_ambulantni_kontrola: state => state.d_ambulantni_kontrola,                                                                                              

        // options: state => state.options,

        l_insurance_companies: state => state.l_insurance_companies,

      }),

      ...mapGetters({

      }),


      chb_fokal_deficit: {
        get () {
          return this.exam_01.chb_fokal_deficit;
        },
        set (value) {
          let mykey = "chb_fokal_deficit";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      chb_fokal_deficit_data: {
        get () {
          return this.exam_01.chb_fokal_deficit_data;
        },
        set (value) {
          let mykey = "chb_fokal_deficit_data";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      chb_fokal_deficit_n: {
        get () {
          return this.exam_01.chb_fokal_deficit_n;
        },
        set (value) {
          let mykey = "chb_fokal_deficit_n";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },      

      chb_fokal_deficit_n_data: {
        get () {
          return this.exam_01.chb_fokal_deficit_n_data;
        },
        set (value) {
          let mykey = "chb_fokal_deficit_n_data";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      chb_epilepsie: {
        get () {
          return this.exam_01.chb_epilepsie;
        },
        set (value) {
          let mykey = "chb_epilepsie";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      chb_epilepsie_data: {
        get () {
          return this.exam_01.chb_epilepsie_data;
        },
        set (value) {
          let mykey = "chb_epilepsie_data";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      chb_nth: {
        get () {
          return this.exam_01.chb_nth;
        },
        set (value) {
          let mykey = "chb_nth";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      chb_nth_data: {
        get () {
          return this.exam_01.chb_nth_data;
        },
        set (value) {
          let mykey = "chb_nth_data";
          this.m_exam_01_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },      


      ex_pat_name: {
        get () {
          return this.patient.pat_name;
        },
        set (value) {
          let mykey = "pat_name";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      ex_pat_surname: {
        get () {
          return this.patient.pat_surname;
        },
        set (value) {
          let mykey = "pat_surname";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },

      ex_pat_insu_num: {
        get () {
          return this.patient.pat_insu_num;
        },
        set (value) {
          let mykey = "pat_insu_num";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },        

      ex_pat_id_inco: {
        get () {
          return this.patient.pat_id_inco;
        },
        set (value) {
          let mykey = "pat_id_inco";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },
      
      ex_pat_birth_date: {
        get () {
          return this.patient.pat_birth_date;
        },
        set (value) {
          let mykey = "pat_birth_date";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      
      ex_pat_gender: {
        get () {
          return this.patient.pat_gender;
        },
        set (value) {
          let mykey = "pat_gender";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_pat_street: {
        get () {
          return this.patient.pat_street;
        },
        set (value) {
          let mykey = "pat_street";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },   
      
      ex_pat_city: {
        get () {
          return this.patient.pat_city;
        },
        set (value) {
          let mykey = "pat_city";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_pat_zip_code: {
        get () {
          return this.patient.pat_zip_code;
        },
        set (value) {
          let mykey = "pat_zip_code";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      
      ex_pat_country: {
        get () {
          return this.patient.pat_country;
        },
        set (value) {
          let mykey = "pat_country";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      
      ex_pat_phone: {
        get () {
          return this.patient.pat_phone;
        },
        set (value) {
          let mykey = "pat_phone";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },   
      
      ex_pat_email: {
        get () {
          return this.patient.pat_email;
        },
        set (value) {
          let mykey = "pat_email";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 

      ex_prvni_priznak_pos: {
        get () {
          return this.exam.ex_prvni_priznak_pos;
        },
        set (value) {
          let mykey = "ex_prvni_priznak_pos";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      ex_delka_anamnezy: {
        get () {
          return this.exam.ex_delka_anamnezy;
        },
        set (value) {
          let mykey = "ex_delka_anamnezy";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 

      ex_neurol_deficit: {
        get () {
          return this.exam.ex_neurol_deficit;
        },
        set (value) {
          let mykey = "ex_neurol_deficit";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },
      
      ex_neurol_deficit_a_n: {
        get () {
          return this.exam.ex_neurol_deficit_a_n;
        },
        set (value) {
          let mykey = "ex_neurol_deficit_a_n";
          this.m_patient_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },       

      ex_lansky_skore: {
        get () {
          return this.exam.ex_lansky_skore;
        },
        set (value) {
          let mykey = "ex_lansky_skore";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_ecog_skore: {
        get () {
          return this.exam.ex_ecog_skore;
        },
        set (value) {
          let mykey = "ex_ecog_skore";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },   

      ex_d_skola: {
        get () {
          return this.exam.ex_d_skola;
        },
        set (value) {
          let mykey = "ex_d_skola";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      
      ex_d_primarni_nador: {
        get () {
          return this.exam.ex_d_primarni_nador;
        },
        set (value) {
          let mykey = "ex_d_primarni_nador";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },
      
      ex_d_dalsi_nador: {
        get () {
          return this.exam.ex_d_dalsi_nador;
        },
        set (value) {
          let mykey = "ex_d_dalsi_nador";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_d_primarne_observace: {
        get () {
          return this.exam.ex_d_primarne_observace;
        },
        set (value) {
          let mykey = "ex_d_primarne_observace";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },  
      
      ex_d_observace_nadoru: {
        get () {
          return this.exam.ex_d_observace_nadoru;
        },
        set (value) {
          let mykey = "ex_d_observace_nadoru";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },
      
      ex_d_ukoncena_pro: {
        get () {
          return this.exam.ex_d_ukoncena_pro;
        },
        set (value) {
          let mykey = "ex_d_ukoncena_pro";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_d_datum_ukonceni: {
        get () {
          return this.exam.ex_d_datum_ukonceni;
        },
        set (value) {
          let mykey = "ex_d_datum_ukonceni";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 
      
      ex_d_operace: {
        get () {
          return this.exam.ex_d_operace;
        },
        set (value) {
          let mykey = "ex_d_operace";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      }, 

      ex_d_pooperacni_stav: {
        get () {
          return this.exam.ex_d_pooperacni_stav;
        },
        set (value) {
          let mykey = "ex_d_pooperacni_stav";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },      
      
      ex_d_ambulantni_kontrola: {
        get () {
          return this.exam.ex_d_ambulantni_kontrola;
        },
        set (value) {
          let mykey = "ex_d_ambulantni_kontrola";
          this.m_exam_item( {mykey, value} );
          // this.a_lab_req_save({ lab_req: this.lab_req, author: this.author });
        }
      },       
      
    },

    methods: {
      ...mapMutations({
        m_patient_item: 'm_patient_item',
        m_exam_item: 'm_exam_item',
        m_exam_01_item: 'm_exam_01_item',

      }),


      ...mapActions({
        // a_lab_req_save: 'a_lab_req_save',

      }),


      onSubmit() {
        console.log('submit!');
      },


      change_lr_req_insu_num(value) {
        let validni = true

        if ((value.length  > 5) && (/^0?\d+$/.test(value))) {
          let yy = '';
          let mm = '';
          let dd = '';

          for (let strIndex in value) {
            if (strIndex == 0) {
              yy += value[strIndex];
            } 
            else if (strIndex == 1) {
              yy += value[strIndex];
            }
            else if (strIndex == 2) {
              mm += value[strIndex];
            }
            else if (strIndex == 3) {
              mm += value[strIndex];
            }
            else if (strIndex == 4) {
              dd += value[strIndex];
            }
            else if (strIndex == 5) {
              dd += value[strIndex];
            } else {

            }
          }
          let xyy = parseInt(yy);
          let xmm = parseInt(mm);
          let xdd = parseInt(dd);
          let xgender = "";

          if (xyy > 21) {
            xyy = 1900 + xyy;
          } else {
            xyy = 2000 + xyy;
          }

          if (xmm < 13) {
            xgender = "2";
            xmm -= 1;
          } else if (xmm > 50 && xmm < 63) {
            xgender = "1";
            xmm -= 51;
          } else {
            xgender = "0";
            xmm = 0;
          }

          if (xdd > 31) {
            xdd -= 50;
          } 

          this.m_lab_req_birth_date( {xyy: xyy, xmm: xmm, xdd: xdd});
          this.m_lab_req_gender(xgender);
        }
      },

      change_inco(value) {
        console.log(value);
        
      },


    },



    beforeCreate () {
      console.log("C-beforeCreate Cascader...");
    },

    created () {
      console.log("C-created Cascader...");
    },
 
    beforeMount () {
    },

    mounted () {
      console.log("C-mounted Cascader...");

    },

    beforeUpdate () {
    },

    updated () {

    },

    afterDestroy () {
    },

    destroyed () {
    },

  }


</script>

<style lang="scss" scoped>
.dolu {
  padding-top: 120px !important;
} 

.el-cascader {
  display: block;
}

.text-01 {
  text-align: left !important;
  color: rgb(24, 39, 126) !important; 
  font-size: 30px !important;  
  font-weight: 700 !important; 
  padding-top: 20px !important;  
}  

.text-02 {
  text-align: left !important;
  color: #416c97 !important; 
  font-size: 20px !important;  
  font-weight: 900 !important; 
  padding-bottom: 40px !important;    
}

.text-03 {
  color: white !important; 
}

.el-form-item__label {
  color: #328a45 !important; 
  font-size: 40px !important;  
  font-weight: 900 !important; 
}

.card-01 {
  background-color: #ebeff3 !important;
  padding: 20px 50px !important;
  border-radius: 5px !important;
  
} 

.card-02 {
  background-color: #c6d2dd !important;
  padding: 0px !important;
  border-radius: 5px !important;
  text-align: left !important;
} 

.card-03 {
  background-color: #f7f1c0 !important;
  padding: 0px !important;
  border-radius: 5px !important;
  text-align: left !important;
} 

.el-input {
  padding: 2px !important;   
}

.el-select {
  padding: 2px !important;   
}  

.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }

h3 {
  color: rgb(221, 168, 23) !important;
  font-size: 20px !important;  
  font-weight: 900 !important;   
  padding: 0 !important;  
  margin-bottom: 5px !important;
  text-align: left !important;
}  

h5 {
  background-color: #1e466e !important;
  color: rgb(241, 208, 115) !important;  
  font-size: 15px !important;  
  font-weight: 800 !important;   
  padding: 3px !important;  
  text-align: left !important;
  border-top-left-radius: 5px !important;
  border-top-right-radius: 5px !important; 
} 

.bor {
 border: #e1e7ee 1px solid !important;
 border-radius: 5px !important;
  }  
}
</style>
